import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  CardSetTransformationService,
  DialogService, DspxCardSetBaseFormComponent,
  DspxCoreModule
} from "dspx-core";
import { BaseCardSetDetailComponent } from "../base-card-set-detail-component/base-card-set-detail.component";
import { API_ENDPOINT_KEYS } from "../../constants/api-endpoints.constants";
import { TEMPLATES, VERSIONS } from "../../constants/templates.constants";
import { ActivatedRoute, Router } from "@angular/router";
import { AppDataService } from "../../services/app-data.service";

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrl: './report-list.component.scss'
})
export class ReportListComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

  formServiceEndpoint: string = API_ENDPOINT_KEYS.getReportListConfigAndResponse;
  templateId: number = TEMPLATES.reportList;
  versionNo: number = VERSIONS.latest;

  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value;
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected dialogService: DialogService,
    protected appDataService: AppDataService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  formLoaded($event) {

  }

}
